// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"d8978d16","347":"95d9b424","593":"07224356","787":"0b364719"}[chunkId] + ".chunk.js";
};